import { WorkflowFiltersController } from './workflow-filters.controller'

function workflowFiltersDirective () {
  return {
    restrict: 'E',
    scope: {
      viewMode: '<',
      boardId: '<',
      showFilters: '='
    },
    templateUrl: '/workflow/directives/workflow-filters/workflow-filters-directive.html?$$REVISION$$',
    controller: WorkflowFiltersController
  }
}

export { workflowFiltersDirective }
